export enum ApplicantPositionEnum {
    None = 0,
    Read_Only = 1,
    Member_Administrator = 2,
    Group_Administrator = 3
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/enums/applicant-position.enum.ts